module.exports = __webpack_public_path__ + "img/cake_ios_802.png";